import { Image, Linking, Pressable, Text, View, useWindowDimensions } from 'react-native';
import { useAnalytics } from 'services/analytics/useAnalytics';
import theme from 'theme';

import { BandshopProductItem } from './SectionBandshop';

import { useProgram } from 'components/Program/context';

const BandshopCard: React.FC<BandshopProductItem> = ({
  name: title,
  link,
  image,
  isDefault = false,
}) => {
  const program = useProgram();
  const analytics = useAnalytics();
  const { width: screenWidth } = useWindowDimensions();

  const isSmallScreen = screenWidth < 480;

  const mediumCardWidth = isSmallScreen ? 148 : 159;
  const mediumCardHeight = isSmallScreen ? 197 : 212;

  const openExternalLink = async (url: string) => {
    try {
      await Linking.openURL(url);
    } catch (err) {
      console.error(`Erro ao abrir o link: ${url}`, err);
    }
  };

  const onPress = () => {
    analytics.triggerBandshopProductButtonActionEvent({
      productTitle: title,
      programId: program?._id,
      programTitle: program?.title,
      programAgeRating: program?.rating,
    });

    openExternalLink(link);
  };

  return (
    <View
      style={{
        width: mediumCardWidth,
        height: mediumCardHeight,
        borderRadius: 16,
        overflow: 'hidden',
        backgroundColor: isDefault ? 'transparent' : theme.colors.base.darkBlue,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 2,
        borderColor: theme.colors.primary[600],
        paddingVertical: isSmallScreen ? 12 : 16,
      }}>
      <Image
        source={typeof image === 'string' ? { uri: image } : image}
        style={{
          width: 90,
          height: 90,
          justifyContent: 'center',
          borderRadius: 8,
          overflow: 'hidden',
        }}
      />

      <Text
        numberOfLines={3}
        style={{
          marginTop: isSmallScreen ? 4 : 8,
          fontSize: 12,
          fontWeight: '600',
          textAlign: 'center',
          color: '#fff',
          lineHeight: isSmallScreen ? 14 : 18,
          minHeight: isDefault ? undefined : isSmallScreen ? 14 * 3 : 18 * 3,
          paddingHorizontal: 17,
        }}>
        {title}
      </Text>
      <Pressable
        style={{
          marginTop: isSmallScreen ? 4 : 8,
          paddingVertical: 6,
          paddingHorizontal: 12,
          backgroundColor: theme.colors.primary[500],
          borderRadius: 34,
          marginBottom: 0,
        }}
        onPress={onPress}>
        <Text style={{ color: '#fff', fontWeight: '600', fontSize: 12 }}>
          {isDefault ? 'Ver mais' : 'Ver detalhes'}
        </Text>
      </Pressable>
    </View>
  );
};

export default BandshopCard;
